var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lolth-more-text-viewer',{attrs:{"content":_vm.mValue,"line":_vm.mLine}})}
var staticRenderFns = []

export { render, staticRenderFns }